import React from 'react';
import { Cpu, Users, Clock, DollarSign, Shield, Sparkles } from 'lucide-react';
import { strengths } from '../mockData';

const iconMap = {
  Cpu,
  Users,
  Clock,
  DollarSign,
  Shield,
  Sparkles
};

const Strengths = () => {
  return (
    <section id="strengths" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Our Competitive Strengths
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-slate-600 leading-relaxed">
            What sets us apart in the competitive printing industry? Our unwavering commitment 
            to quality, innovation, and customer satisfaction backed by world-class capabilities.
          </p>
        </div>

        {/* Strengths Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {strengths.map((strength) => {
            const Icon = iconMap[strength.icon];
            return (
              <div 
                key={strength.id}
                className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-blue-600 group"
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-600 transition-colors">
                      <Icon className="text-blue-600 group-hover:text-white transition-colors" size={28} />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-blue-600 transition-colors">
                      {strength.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed">
                      {strength.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 bg-slate-900 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: 'repeating-linear-gradient(45deg, #3b82f6 0, #3b82f6 1px, transparent 0, transparent 50%)',
              backgroundSize: '15px 15px'
            }}></div>
          </div>
          
          <div className="relative z-10">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Ready to Experience the Difference?
            </h3>
            <p className="text-slate-300 text-lg mb-8 max-w-2xl mx-auto">
              Trusted by clients who value precision and quality, we deliver printing that makes an impact. Let's discuss how we can elevate your brand.
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('enquiry');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl inline-flex items-center gap-2"
            >
              Get Started Today
              <Sparkles size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Strengths;
